import React from 'react';

const TrackingForm = ({ 
  formData, 
  loading, 
  handleChange, 
  handleSubmit 
}) => {
  return (
    <div className="mt-8 p-4 sm:p-6 md:p-8 rounded-2xl bg-white/90 backdrop-blur-md border border-black/10 shadow-xl hover:-translate-y-1 hover:shadow-2xl transition-all duration-300">
      <h2 className="mb-4 font-bold text-black font-poppins text-center text-2xl">
        Track Your Ticket
      </h2>

      <p className="mb-4 text-gray-600 font-medium tracking-wide text-sm font-poppins text-center animate-fade-in">
        Enter your tracking ID below to check the status
      </p>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div className="relative">
          <label htmlFor="trackingId" className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
            Tracking ID
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
              </svg>
            </div>
            <input
              type="text"
              id="trackingId"
              name="trackingId"
              required
              value={formData.trackingId}
              onChange={handleChange}
              placeholder="TK-XXXXXXXX"
              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-black transition-all duration-300 font-poppins"
            />
          </div>
          <p className="mt-1 text-sm text-gray-500 font-poppins">
            Enter your ticket ID in the format TK-XXXXXXXX
          </p>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="py-4 px-6 text-lg font-semibold rounded-lg bg-black text-white shadow-lg hover:bg-gray-800 hover:shadow-xl hover:-translate-y-0.5 active:translate-y-0 transition-all duration-300 flex items-center justify-center gap-2 font-poppins disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:transform-none disabled:hover:shadow-lg"
        >
          {loading ? (
            <>
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              Searching...
            </>
          ) : (
            <>
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
              </svg>
              Track Ticket
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default TrackingForm;